// Bottom-left vitals: HUNGER + THIRST bars, driven by the server-synced survival stats.

import { injectTheme } from "./theme.js";
import { statsStore } from "../items/statsStore.js";

const STYLE_ID = "ghostland-vitals-style";
const CSS = `
#gl-vitals {
  position: fixed; left: 16px; bottom: 16px; z-index: 24;
  display: flex; flex-direction: column; gap: 6px; width: 168px;
  font-family: ui-monospace, "SFMono-Regular", Menlo, monospace; user-select: none;
}
#gl-vitals .row { display: flex; align-items: center; gap: 8px; }
#gl-vitals .ic { width: 14px; text-align: center; font-size: 12px; }
#gl-vitals .bar {
  position: relative; flex: 1; height: 9px; border-radius: 4px; overflow: hidden;
  background: var(--gl-panel-2); box-shadow: inset 0 0 0 1px var(--gl-border);
}
#gl-vitals .fill { position: absolute; inset: 0; width: 100%; transition: width .25s ease; }
#gl-vitals .hunger .fill { background: linear-gradient(#e8a23a, #c8761f); }
#gl-vitals .thirst .fill { background: linear-gradient(#49b4e0, #2b7fb8); }
#gl-vitals .pct { font-size: 9px; color: var(--gl-muted); width: 26px; text-align: right; }
`;

let root: HTMLDivElement | null = null;
let hungerFill: HTMLDivElement | null = null, hungerPct: HTMLSpanElement | null = null;
let thirstFill: HTMLDivElement | null = null, thirstPct: HTMLSpanElement | null = null;

/** Mount the hunger/thirst HUD (idempotent). Seeds placeholder values. */
export function mountVitalsHud(): void {
  if (root) return;
  injectTheme();
  if (!document.getElementById(STYLE_ID)) {
    const s = document.createElement("style"); s.id = STYLE_ID; s.textContent = CSS; document.head.appendChild(s);
  }
  root = document.createElement("div");
  root.id = "gl-vitals";
  root.innerHTML =
    `<div class="row hunger"><span class="ic">🍖</span><div class="bar"><div class="fill"></div></div><span class="pct"></span></div>` +
    `<div class="row thirst"><span class="ic">💧</span><div class="bar"><div class="fill"></div></div><span class="pct"></span></div>`;
  document.body.appendChild(root);
  hungerFill = root.querySelector(".hunger .fill");
  hungerPct = root.querySelector(".hunger .pct");
  thirstFill = root.querySelector(".thirst .fill");
  thirstPct = root.querySelector(".thirst .pct");
  // Live hunger/thirst from the server-synced stats.
  statsStore.subscribe((s) => setVitals(s.stats.hunger ?? 100, s.stats.thirst ?? 100));
}

/** Update hunger/thirst (0..100). */
export function setVitals(hunger: number, thirst: number): void {
  const h = Math.max(0, Math.min(100, Math.round(hunger)));
  const t = Math.max(0, Math.min(100, Math.round(thirst)));
  if (hungerFill) hungerFill.style.width = `${h}%`;
  if (hungerPct) hungerPct.textContent = `${h}%`;
  if (thirstFill) thirstFill.style.width = `${t}%`;
  if (thirstPct) thirstPct.textContent = `${t}%`;
}
